const Header = () => {
    return (  
        <div className="header"> 
        <h1>Dictionary App</h1> 
        <h2>Lets Create A Word </h2>
        </div>
     );
}
 
export default Header;